import { endpoint, regex } from "../../common/constant"
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod"

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.academic_career.getAllActive,
            "academicCareerDispValue",
            "id"
        ),
        dropdownMapping(
            endpoint.groupCode.getAllActive,
            "groupCodeDispValue",
            "id"
        ),
        dropdownMapping(
            endpoint.companyCode.getAllActive,
            "companyCodeDispValue",
            "id"
        ),
        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "id",
            "businessAreaDesc"
        ),
        dropdownMapping(
            endpoint.term.getAllActive,
            "termDispValue",
            "id"
        ),
        fetchAllPromisedData(endpoint.treeView)

    ])

    return{
        academicCareer : dropdown[0],
        academicGroup : dropdown[1],
        companyCode : dropdown[2],
        businessArea: dropdown[3],
        term : dropdown[4],
        categories : dropdown[5]?.filter(category => category?.categoryCode === 'S')
    }
}

export const fetchVoucherConfigs = async(req) => {
    return fetchAllPostPromisedData(endpoint.voucherSetup.search, req);
}

export const createUpdateVoucherConfig = (rowForm, isPANIndiaConfig) => {
    
    const {id, businessGroup, companyCode, academicCareer, term, businessArea, courseId, ratio, status, categoryId, subCategoryId, subSubCategoryId} = rowForm;

    const req = {
        businessGroupId : businessGroup?.value,
        companyCodeId : companyCode?.value,
        academicCareerId : academicCareer?.value,
        academicCareerValue : academicCareer?.label,
        termId : term?.value,
        termValue : term?.label,
        businessAreaId : isPANIndiaConfig ? 0 : businessArea?.value,
        businessAreaValue : isPANIndiaConfig ? null : businessArea?.label,
        courseId : courseId?.value,
        ratio,
        status,
        categoryId,
        subCategoryId,
        subSubCategoryId
    }

    let url = endpoint.voucherSetup.create;
    let method = 'post';

    if(!rowForm?.isNew){
        url = `${endpoint.voucherSetup.basePath}/${id}`;
        method = 'put';
    }

    return fetchAllPostPromisedData(url, req, method);

    

}

export const newRow = (isPANIndiaConfig) =>  ({
    businessGroup : "",
    companyCode : "",
    academicCareer : "",
    term : "",
    ...(!isPANIndiaConfig ? { businessArea : "", courseId : "" } : {}),
    categoryId : "",
    ratio : "",
    status : "ACTIVE",
});

export const updateConfigsData = (data, dropdowns) => {

    const {
        academicCareer,
        academicGroup,
        companyCode,
        businessArea,
        term
    } = dropdowns;

    return data?.map(row => {
        const {
        businessGroupId,
        companyCodeId,
        academicCareerId,
        termId,
        businessAreaId,
    } = row;

    return({
        ...row,
        businessGroup : academicGroup?.find(el => el?.value === businessGroupId),
        companyCode : companyCode?.find(el => el?.value === companyCodeId),
        academicCareer : academicCareer?.find(el => el?.value === academicCareerId),
        term : term?.find(el => el?.value === termId),
        businessArea : businessArea?.find(el => el?.value === businessAreaId),
    })
})
}

export const searchInputOptions = [
    {
        label: 'Business Area',
        keyName: 'businessAreaValue',
        placeholder: 'Search by BU',
    },
    {
        label: 'Course ID',
        keyName: 'courseId',
        placeholder: 'Search by Course ID',
        regex: regex.numeric,
    },
]
